import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelpDev } from './HelpDev';
import { TokenProvider } from './TokenProvider';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {ResetCache} from "./ResetCache";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        path: '/',
        element: <HelpDev />
    },
    {
        path: '/reset-cache',
        element: <ResetCache />
    }
])

root.render(
  <React.StrictMode>
    <TokenProvider>
      <RouterProvider router={router} />
    </TokenProvider>
  </React.StrictMode>
);
